import {
  type BackyardLocationId,
  isBackyardLocationId,
} from '@/world-prototype/camera/sceneWorld';

/** City-only HUD label for backyard presence spaces (no state suffix). */
const BACKYARD_CITY_LABELS: Readonly<Record<BackyardLocationId, string>> = {
  hubert: 'Hubert',
  raleigh: 'Holly Springs',
  'spanish-fork': 'Spanish Fork',
};

export function backyardCityLabel(locationId: string): string | null {
  return isBackyardLocationId(locationId)
    ? BACKYARD_CITY_LABELS[locationId]
    : null;
}
